import { create } from 'zustand'

const useAuthStore = create((set) => ({
    isUserSignedIn: false,
    theme: "default",
    navigationThemeOverride: { colors: {}, fonts: {} },
    showOrgSelectScreen: false,
    isEmulating: false,
    emulatedUserName: undefined,
    lastSentryEventID: undefined,
    setLastSentryEventID: (lastSentryEventID) => set(() => ({ lastSentryEventID })),
    setIsUserSignedIn: (isUserSignedIn) => set(() => ({ isUserSignedIn })),
    setTheme: (theme) => set(() => ({ theme })),
    setNavigationThemeOverride: (navigationThemeOverride) => set(() => ({ navigationThemeOverride })),
    setShowOrgSelectScreen: (showOrgSelectScreen) => set(() => ({ showOrgSelectScreen })),
    setEmulation: (isEmulating, emulatedUserName = undefined) => set(() => ({ isEmulating, emulatedUserName }))
}))

export default useAuthStore